import React, { useState, useEffect, useRef } from 'react';
import customHeaders, { getSpace } from '../../../../common/headers';
import useGeneralStore from '../../../../store/general';
import { ButtonBasic, usePagination, TableBox } from "@lk-gtcom/ecomlab-components";
import { ModalAddFields } from '../Modal/ModalAddFields/ModalAddFields';
import { useShallow } from 'zustand/react/shallow';
import { useDataTable } from '../../../../common/hooks';
import './ServicesCRM.scss';

interface ServicesCRMProps { }

type PaginatorParams = {
    page?: number;
    limit?: number;
    // Добавьте нужные поля
};

type PaginatorRefType = {
    page?: number;
    limit?: number;
    params: PaginatorParams;
    setTotal?: (total: number) => void;
};

interface TableProps {
    filters: any;
    sort: any;
    total: number;
    loading: boolean;
}

interface SetTableFuncs {
    setLoading: (loading: boolean) => void;
}

const ServicesCRM = ({ }: ServicesCRMProps) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const {
        isModalServices,
        setIsModalServices,
        currentServices,
        setCurrentServices
    } = useGeneralStore(
        useShallow((state) => ({
            currentServices: state.currentServices,
            isModalServices: state.isModalServices,
            setCurrentServices: state.setCurrentServices,
            setIsModalServices: state.setIsModalServices,
        }))
    );
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };

    const [servicesList, setServicesList] = useState([])
    const [isModalFields, setIsModalFields] = useState(false)
    const [load, setLoad] = useState(true)

    // Таблица
    const [isTableRequest, setIsTableRequest] = useState(false);
    const paginatorRef = useRef<PaginatorRefType>()
    const [setTable, tableProps, setTableFuncs] = useDataTable(
        paginatorRef.current?.setTotal,
        paginatorRef
    ) as any
    const { setLoading } = setTableFuncs as SetTableFuncs;
    const { loading, sort, filters } = tableProps as TableProps;

    const btns = [
        {
            btn: 'Удалить',
            func: (e: any) => {
                fetchDeleteServices(e)
            },
        },
    ];

    // Пагинация
    const paginatorCallback = useRef();
    const [
        page,
        limit,
        total,
        setTotal,
        Paginator,
        resetPaginator,
        paginatorTransition,
    ] = usePagination(
        paginatorCallback.current,
        [],
        paginatorRef?.current?.params
    );

    const fetchTableData = (params: any[], abortController = new AbortController()) => {
        let _sort;
        let filtersParam = [];

        if (params) {
            [_sort, filtersParam] = params;
        }

        // Устанавливаем loading в true только если запрос не прерван
        if (!abortController.signal.aborted) {
            setLoading(true);
        }

        let url = ` https://portals.ecomru.ru/api/crm/services/table_view`;

        const body = JSON.stringify({
            page: paginatorRef.current?.page,
            limit: paginatorRef.current?.limit,
            filters: Array.isArray(filtersParam) ? filtersParam : filters,
            search: '',
            order_field: _sort?.[0] || sort?.[0],
            order_direction: _sort?.[1] || sort?.[1]
        });

        fetch(url, { body, method: 'POST', headers, signal: abortController.signal })
            .then(async (res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    const err = await res.json();
                    throw new Error(JSON.stringify(err));
                }
            })
            .then((json) => {
                setTable(json);
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                if (!abortController.signal.aborted) {
                    setLoading(false);
                }
            });
    };

    // Удаление услуги
    const fetchDeleteServices = (id: string) => {
        let url = ` https://portals.ecomru.ru/api/crm/services/${id}`

        fetch(url, { method: 'DELETE', headers })
            .then((res) => res.json())
            .then((json) => {
                setIsTableRequest(!isTableRequest)
            })
            .catch((err) => console.error(err));
    };

    useEffect(() => {
        if (!isModalServices) {
            const abortController = new AbortController();
            fetchTableData([], abortController)
            return () => abortController.abort();
        }
    }, [isTableRequest, isModalServices]);

    const contextMenuArr = [
        {
            label: 'Удалить',
            onClick: (e: any) => {
                fetchDeleteServices(e?.['id услуги']);
            },
        },
    ];

    const onAction = (e: any) => {
        setCurrentServices(e?.['id услуги'])
        setIsModalServices(true)
    }

    return (
        <>
            {isModalFields && <ModalAddFields
                setIsModal={setIsModalFields}
                stringUrl='services'
            />}

            <div className={`services-CRM`}>
                <div className={`services-CRM__content`}>
                    <div className={`services-CRM__btn-group`}>
                        <ButtonBasic
                            pink
                            text='+ Добавить услугу'
                            onClick={(e: boolean) => setIsModalServices(true)}
                        />

                        <ButtonBasic
                            whitePink
                            text='+ Создать поля'
                            onClick={(e: boolean) => setIsModalFields(true)}
                        />
                    </div>

                    <TableBox
                        {...tableProps}
                        ref={paginatorRef}
                        paginator={true}
                        fetchCallback={fetchTableData}
                        contextMenuArr={contextMenuArr}
                        onAction={onAction}
                    />
                </div>
            </div >
        </>
    );
};

export { ServicesCRM };